<section id="navbar-menu-trigger"></section>
@if (user$ | async; as _user) {
<!--begin::Chat-->
@if (!hideCart) {
<div class="app-navbar-item me-4" [ngClass]="itemClass">
  <div [ngClass]="btnClass" class="position-relative" id="kt_drawer_cart_toggle">
    <app-keenicon name="handcart" class="fs-2"></app-keenicon>
    <!-- The count, not a blinking dot. A bare red dot says "something
         happened" and nothing else — after adding a course you could not tell
         from the header whether the cart held one item or four, and a blinking
         alarm colour is a strange way to report good news. -->
    @if(useCart()?.course_list?.length; as cartCount){
    <span class="cart-count" data-testid="cart-count">{{ cartCount }}</span>
    }
  </div>
</div>
}

<!--end::Chat-->

<!--begin::Notifications-->
<!-- <div class="app-navbar-item" [ngClass]="itemClass">
  <div
    [ngClass]="btnClass"
    data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
    data-kt-menu-attach="parent"
    data-kt-menu-placement="bottom-end"
  >
    <app-keenicon name="notification" class="fs-2"></app-keenicon>
  </div>
  <app-notifications-inner></app-notifications-inner>
</div> -->
<!--end::Notifications-->

<!--begin::Language mode-->
<!-- <div class="app-navbar-item" [ngClass]="itemClass">
    <app-lang-switcher
      [toggleBtnClass]="btnClass"
      toggleBtnClass="{`btn-active-light-primary btn-custom ${toolbarButtonHeightClass}`}"
    ></app-lang-switcher>
  </div> -->
<!--end::Theme mode-->

<!--begin::User menu-->
<div class="app-navbar-item" [ngClass]="itemClass">
  <!--begin::Menu wrapper-->
  <div id="user-dropdown" class="cursor-pointer symbol symbol-circle" [ngClass]="userAvatarClass" data-kt-menu-trigger="click"
    data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" (click)="_setUserToggle($event)">
    <!-- `_user.data.image_url` is the raw, relative path from `/users/current`
         — `UserModel.setUser` (which would have made it absolute) is never
         actually called anywhere in this app, so it still needs `apiFileUrl`
         here. No `blank.png` though: a person icon instead, like every other
         avatar placeholder on the site. -->
    @if (_user.data.image_url) {
    <img [src]="environment.apiFileUrl + _user.data.image_url" class="object-fit-cover" [attr.alt]="_user.data.full_name" />
    } @else {
    <span class="symbol-label bg-light-primary text-primary">
      <app-keenicon name="user" class="fs-2 text-primary"></app-keenicon>
    </span>
    }
  </div>
  <app-user-inner data-kt-menu="true"></app-user-inner>
  <!--end::Menu wrapper-->
</div>
<!--end::User menu-->

} @else {
<!--begin::Sign in-->
<!-- A visitor who is not signed in used to get an empty right-hand side: no
     cart, no avatar, and nothing offering a way in. The member-only menus are
     hidden from them now, so without this there is no visible route to signing
     in at all from the header. The dialog is the same one the auth guard opens
     — this app has no /login route. -->
<div class="app-navbar-item" [ngClass]="itemClass">
  <button class="btn btn-sm btn-primary fw-bold rounded-pill px-5" type="button" data-testid="header-login"
    (click)="openLogin()">
    {{ "AUTH.SIGN_IN" | translate }}
  </button>
</div>
<!--end::Sign in-->
}

@if (appHeaderDefaulMenuDisplay) {
<div class="app-navbar-item d-lg-none ms-2 me-n3" title="Show header menu">
  <div class="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_header_menu_toggle">
    <!-- Three lines. `element-4` was a duotone pair of squares that read on a
         phone as one solid block and one faded one; `burger-menu-2`, despite
         the name, is a rounded square full of dots. `burger-menu-5` is the
         hamburger. Outline so it stays a single clean glyph at 35px. -->
    <app-keenicon name="burger-menu-5" type="outline" class="fs-1" [ngClass]="btnIconClass"></app-keenicon>
  </div>
</div>
}